<template>
  <label>
    <div>{{title}}</div>
    <input :title="tip" type="checkbox" v-model="value">
  </label>
</template>

<script>
export default {
  props: ['title', 'defaultValue', 'tip'],
  data () {
    return {
      value: false
    }
  },
  mounted () {
    this.value = this.defaultValue
  },
  watch: {
    defaultValue () {
      this.value = this.defaultValue
    },
    value () {
      if (this.value !== this.defaultValue) {
        this.$emit('update', this.value)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@media screen and (orientation: landscape) {
  label {
    display: flex;
    align-items: center;
    gap: 8px;
    &>div{
      font-weight: 500;
      font-size: 18px;
      color: var(--color-pri);
      letter-spacing: .1em;
      white-space: nowrap;
    }
  }
  input[type=checkbox] {
    border-radius: 10px;
    appearance: none;
    height: 21px;
    width: 40px;
    background-color: var(--color-confirm);
    position: relative;
    &::before {
      content: '';
      display: inline-block;
      width: 17px;
      height: 17px;
      background-color: #FFFFFF;
      position: absolute;
      top: 2px;
      left: 2px;
      border-radius: 8px;
    }
    &:checked {
      background-color: #A3C777;
      &::before {
        left: auto;
        right: 2px;
      }
    }

  }
}
</style>
<style lang="scss" scoped>
@media screen and (orientation: portrait) {}
</style>
